/* eslint-disable max-classes-per-file */
export default class CountryError extends Error {
  constructor(message, type) {
    super(message);
    this.name = 'CountryError';
    this.type = type;
  }
}
